export default "__VITE_ASSET__BMSNliMb__"